import { isSmallMobile, isMobile, isTablet } from '../services/mql-service';

export class LinkList extends DrupalBehavior {
  onContent(context) {
    const grids = document.querySelectorAll('.link-list--items');
    grids.forEach((grid) => {
      const items = grid.querySelectorAll('li');
      let numColumns;

      if (isMobile()) {
        numColumns = 1;
      } else if (isTablet()) {
        numColumns = 2;
      } else {
        numColumns = 3;
      }

      const totalItems = items.length;

      const baseItemsPerCol = Math.floor(totalItems / numColumns);
      const remainder = totalItems % numColumns;

      let currentItemIndex = 0;

      for (let col = 1; col <= numColumns; col++) {
        const itemsInThisCol = baseItemsPerCol + (col <= remainder ? 1 : 0);

        for (let row = 1; row <= itemsInThisCol; row++) {
          if (currentItemIndex >= totalItems) break;

          const item = items[currentItemIndex];

          item.style.gridColumn = col.toString();
          item.style.gridRow = row.toString();

          if (row > 1) {
            item.classList.add('has-divider');
          } else {
            item.classList.remove('has-divider');
          }

          currentItemIndex++;
        }
      }
    });
  }
}

DrupalBehavior.register('rush_theme.components', 'link_list', LinkList);
